import classNames from 'clsx';
import React from 'react';

import { Size } from '@swf/core/enums';

import styles from './Message.scss';

export type MessageSpacingSize = Size.XXSmall | Size.XSmall | Size.Small | Size.Medium | Size.Large;

export interface Props {
  message: React.ReactNode;
  size?: MessageSpacingSize;
  children?: React.ReactNode;
}

const Message: React.FC<Props> = ({ message, size = Size.Large, children }) => {
  const sizeClass = `wrapper${size[0].toUpperCase()}${size.slice(1)}`;
  return (
    <div className={classNames(styles.wrapper, { [styles[sizeClass]]: size })}>
      <div data-testid="sports-message" className={styles.message}>
        {message}
      </div>
      {children}
    </div>
  );
};

export { Message };
